// util/numberConverter.js

const persianNumbers = (number) => {
  const persianNumber = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return number.toString().replace(/\d/g, (digit) => persianNumber[digit]);
};

export default persianNumbers;
